import { AnyAction } from 'redux'
import { call, put } from 'typed-redux-saga'

import services from '@services'
import { HttpStatus } from '@services/base'
import { setLastServiceResponse } from '@store/session/actions'

import { PayloadAutorizacao } from '../types'

interface ErrorType {
  data: string
  status: HttpStatus
}
export default function* postAutorizacaoISafeSaga(action: AnyAction) {
  const payload = action?.payload as PayloadAutorizacao
  try {
    yield* call(
      services.postAutorizacaoISafeService,
      {
        authenticationType: payload.tipoAutenticacao,
        token: payload.token,
        amount: payload.valor,
      },
      payload.conta,
    )
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'postAutorizacaoISafeService' }))
    payload.callback()
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'postAutorizacaoISafeService' }))
    const errorResponse = error as ErrorType
    if (errorResponse?.status === HttpStatus.FORBIDDEN) {
      if (payload?.erroAutorizacao) {
        yield payload?.erroAutorizacao()
      }
    } else {
      yield payload?.erro()
    }
  }
}
